import { SourceApi } from './api/sources';
import { AskBlueJApi } from './api/ask-bluej-api';
import { ThreadApi } from './api/thread';
import { ProjectApi } from './api/project';
import { WorkflowsApi } from '../workflows/api';
import { InteractionsApi } from '../interactions/api';

export type GlobalServices = {
  askBlueJApi: AskBlueJApi;
  threadApi: ThreadApi;
  sourceApi: SourceApi;
  projectApi: ProjectApi;
  workflowsApi: WorkflowsApi;
  interactionsApi: InteractionsApi;
}

type ServicesConfig = {
  backendUrl: string;
}

export function createGlobalServices(servicesConfig: ServicesConfig): GlobalServices {
  const sourceApi = new SourceApi(servicesConfig.backendUrl);
  const askBlueJApi = new AskBlueJApi(servicesConfig.backendUrl);
  const threadApi = new ThreadApi(servicesConfig.backendUrl);
  const projectApi = new ProjectApi(servicesConfig.backendUrl);
  const workflowsApi = new WorkflowsApi(servicesConfig.backendUrl);
  const interactionsApi = new InteractionsApi(servicesConfig.backendUrl);

  return {
    askBlueJApi,
    sourceApi,
    threadApi,
    projectApi,
    workflowsApi,
    interactionsApi
  }
}
